



























import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime, { AnimeTimelineInstance } from "animejs";

@Component({
  components: {}
})
export default class Button extends Vue {
  @Prop({ default: "Empty" })
  text!: string;

  @Prop({ default: false })
  large!: boolean;

  @Prop({ default: false })
  onDarkBackground!: boolean;

  $refs!: {
    wrapper: HTMLElement;
    container: HTMLElement;
  };

  click() {
    this.$emit("click");
  }

  mounted() {
    this.startWavesAnimation();
  }

  /**************************************/
  /************* Анимации ***************/
  /**************************************/
  startWavesAnimation() {
    let waves = this.$refs.wrapper.querySelectorAll<HTMLElement>(".waves > div");
    let value1 = { v: 0 };
    let value2 = { v: 0 };
    this.$nextTick(() => {
      let tl = anime.timeline({ loop: true });
      tl.add({
        targets: value1,
        v: [0, 15],
        update: () => {
          waves[0].style.width = this.$refs.container.offsetWidth + value1.v + "px";
          waves[0].style.height = this.$refs.container.offsetHeight + value1.v + "px";
        },
        duration: 2000,
        easing: "easeOutCubic"
      });
      tl.add({ targets: waves[0], opacity: [0, 1], duration: 80, easing: "linear" }, 0);
      tl.add({ targets: waves[0], opacity: [1, 0], easing: "linear" }, 400);

      tl.add({
        targets: value2,
        v: [0, 15],
        update: () => {
          waves[1].style.width = this.$refs.container.offsetWidth + value2.v + "px";
          waves[1].style.height = this.$refs.container.offsetHeight + value2.v + "px";
        },
        duration: 2000,
        easing: "easeOutCubic"
      }, 500);
      tl.add({ targets: waves[1], opacity: [0, 1], duration: 80, easing: "linear" }, 500);
      tl.add({ targets: waves[1], opacity: [1, 0], easing: "linear" }, 800);
      tl.restart();
    });
  }

  /** Hover анимация - ENTER */
  mouseEnter(event: MouseEvent) {
    let textBlock = this.$refs.wrapper.querySelector(".text");
    let xPercent = (event.layerX / this.$refs.wrapper.offsetWidth) * 100;
    if (xPercent < 12) xPercent = 12;
    if (xPercent > 88) xPercent = 88;

    anime({
      targets: textBlock,
      duration: 500,
      backgroundColor: ["rgba(255, 247, 194, 0)", "rgba(255, 247, 194, 1)"],
      easing: "easeOutQuad",
      color: ['#fff7c2', '#2b1b1b']
    });
  }

  /** Hover анимация - LEAVE */
  mouseLeave() {
    let textBlock = this.$refs.wrapper.querySelector(".text");
    this.$refs.wrapper.style.pointerEvents = "none";
    anime.remove(textBlock);

    anime({
      targets: textBlock,
      duration: 500,
      backgroundColor: "rgba(255, 247, 194, 0)",
      easing: "easeOutQuad",
      color: ['#2b1b1b', '#fff7c2']
    });

    setTimeout(() => {
      if (this.$refs.wrapper) {
        this.$refs.wrapper.style.pointerEvents = "inherit";
      }
    }, 400);
  }
}
